import React, { Component } from 'react';
import Messages from './Messages';
import { supabase } from '../config/supabase';
import { broadcastAdminAuthChange } from '../actions/authEvents';
import { showToast } from '../actions/toastBus';
import { LuMail, LuLock, LuLogIn } from 'react-icons/lu';
import '../stylesheet/style.css';
import '../stylesheet/Login.css';

export default class Login extends Component {
    constructor(props) {
        super(props);
        this.state = { isLoggedIn: false, submitting: false };
        this.emailRef = React.createRef();
        this.passwordRef = React.createRef();
    }

    componentDidMount() {
        this.setState({ isLoggedIn: localStorage.getItem('adminLoggedIn') });
    }

    handleSubmit = async (event) => {
        event.preventDefault();
        const email = this.emailRef.current.value;
        const password = this.passwordRef.current.value;
        if (!email || !password) return;

        this.setState({ submitting: true });
        // Real auth check now happens against Supabase instead of a
        // hardcoded credential baked into the bundle.
        const { error } = await supabase.auth.signInWithPassword({ email, password });
        this.setState({ submitting: false });

        if (error) {
            showToast('Invalid credentials - please try again.', 'error');
            // Only the password gets cleared here - on success the form
            // unmounts entirely (isLoggedIn swaps it for <Messages/>), so
            // there's nothing left to clear and the refs would already be
            // null by the time this ran.
            if (this.passwordRef.current) this.passwordRef.current.value = '';
        } else {
            // Every other page still just reads this flag to gate its own
            // admin UI (unchanged) - Supabase is only the thing deciding
            // whether it gets set, not how the rest of the app checks it.
            localStorage.setItem('adminLoggedIn', true);
            // CustomNavbar lives outside <Routes> and never remounts, so it
            // never re-checked this flag on its own - broadcast the change
            // so it can update itself right now instead of waiting for a
            // full page refresh.
            broadcastAdminAuthChange();
            this.setState({ isLoggedIn: true });
        }
    };

    render() {
        return (
            <div className='base'>
                {this.state.isLoggedIn ? (<Messages />) : (
                    <div className="login-background">
                        <div className="login-card">
                            <span className="login-eyebrow">Admin Access</span>
                            <h1 className="login-title">Welcome back</h1>
                            <p className="login-sub">Sign in to manage the portfolio content.</p>
                            <form onSubmit={this.handleSubmit} className="login-form">
                                <div className="login-field">
                                    <LuMail className="login-field-icon" />
                                    <input
                                        type="email"
                                        className="app-form-control"
                                        placeholder="Email"
                                        ref={this.emailRef}
                                        name="email"
                                        autoComplete="username"
                                        required
                                    />
                                </div>
                                <div className="login-field">
                                    <LuLock className="login-field-icon" />
                                    <input
                                        type="password"
                                        className="app-form-control"
                                        placeholder="Password"
                                        ref={this.passwordRef}
                                        name="password"
                                        autoComplete="current-password"
                                        required
                                    />
                                </div>
                                <button
                                    type="submit"
                                    className="app-form-button login-submit"
                                    disabled={this.state.submitting}
                                >
                                    <LuLogIn /> {this.state.submitting ? 'Signing in...' : 'Login'}
                                </button>
                            </form>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
